import React, { useState } from "react";
import { Container, TextField, Button, Typography, Box } from "@mui/material";
import { authApi } from "../../../api-calls/user-requests";
import AlertBox from "../../../components/AlertBox";

const DeleteLeader = () => {
  const [inputValue, setInputValue] = useState("");
  const [password, setPassword] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("error");
  const [alertMessage, setAlertMessage] = useState("");
  const [isNumber, setIsNumber] = useState(false);
  const [maxLength, setMaxLength] = useState(null);
  const [mobile, setMobile] = useState(null);
  const [email, setEmail] = useState(null);

  const handleClick = (value) => {
    const re = /^[0-9\b]+$/;
    if (re.test(value)) {
      setIsNumber(true);
      setMaxLength(10);
      setMobile(value);
      setEmail(null);
    } else {
      setIsNumber(false);
      setMaxLength(null);
      setMobile(null);
      setEmail(value);
    }
    setInputValue(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputValue || !password) {
      setAlertType("error");
      setAlertMessage("Please fill in all fields");
      setShowAlert(true);
      return;
    }
    // setError("");
    handleDelete();
  };

  const handleDelete = async () => {
    const value = {
      email: email,
      phone: mobile,
      password: password,
    };

    try {
      await authApi.post(`/users/delete_leader`, value, {
        withCredentials: true,
      });
      setAlertType("success");
      setAlertMessage("Account deleted successfully!");
      setShowAlert(true);
    } catch (error) {
      setAlertType("error");
      setAlertMessage(error.response?.data?.message || "Something went wrong");
      setShowAlert(true);
    }
  };

  return (
    <Container maxWidth="xs">
      {showAlert && (
        <AlertBox type={alertType} message={alertMessage} stateName={setShowAlert} />
      )}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <Typography variant="h5" gutterBottom>
          Account Deletion Process
        </Typography>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <TextField
            fullWidth
            label={"Please enter phone number or email address"}
            variant="outlined"
            margin="normal"
            value={inputValue}
            onChange={(e) => handleClick(e.target.value)}
            inputProps={{ maxLength: maxLength }}
            error={
              !isNumber && email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
            }
            helperText={
              !isNumber && email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
                ? "Enter a valid email or Phone Number"
                : ""
            }
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            variant="outlined"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit" variant="contained" color="primary" fullWidth>
            Delete Account
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default DeleteLeader;
